var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgregar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 24.5C2.33328 22.7037 2.85153 20.9456 3.82594 19.4365C4.80036 17.9275 6.18953 16.7317 7.82674 15.9927C9.46395 15.2536 11.2797 15.0028 13.0559 15.2701C14.8322 15.5375 16.4936 16.3118 17.8407 17.5M22.1667 18.6667V25.6667M25.6667 22.1667H18.6667M17.5 9.33333C17.5 12.555 14.8884 15.1667 11.6667 15.1667C8.44505 15.1667 5.83337 12.555 5.83337 9.33333C5.83337 6.11167 8.44505 3.5 11.6667 3.5C14.8884 3.5 17.5 6.11167 17.5 9.33333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgregar);
export default __webpack_public_path__ + "static/media/agregar.0fa6260eb9c15f8c4dc36f32e89e5fdd.svg";
export { ForwardRef as ReactComponent };